import axios from './api/axios'
import api from './api/index'
import store from '../store/store'

export default class Auth {
  constructor() {
    this.$store = store
    this.$api = api(axios)
    this.mounted()
  }

  async loginWith(credentials) {
    try {
      await this.$store.dispatch('updateLoading', true)
      const res = await this.$api.user.logIn(credentials)
      if (!res) return
      if (res.data === null && res.errorMessage) {
        return {success: false, errorMessage: res.errorMessage}
      }

      await this.$store.dispatch('logIn', {...res, rememberMe: credentials.rememberMe})
      await store.dispatch('openAuthModal', false)
      await this.getUserInfo()
      await this.getUserBalance()
    } catch (e) {
      return {success: false, errorMessage: e.errorMessage}
    } finally {
      await this.$store.dispatch('updateLoading', false)
    }
  }

  async getUserInfo() {
    try {
      const res = await this.$api.user.getUserInfo()
      if (res) {
        await this.$store.dispatch('updateUserInfo', res)
      }
    } catch (e) {
    }
  }

  async getUserBalance() {
    try {
      const res = await this.$api.user.getUserBalance()
      if (res) {
        await this.$store.dispatch('getBalance', res)
      }
    } catch (e) {
    }
  }

  async logOut() {
    try {
      await this.$store.dispatch('logOut')
      await this.$api.user.logOut()
    } catch (e) {
      console.error(e)
    }
  }

  async mounted() {
    if (this.$store.getters.isLoggedIn) {
      await this.getUserInfo()
      await this.getUserBalance()
    }
  }
}



// WEBPACK FOOTER //
// ./src/pkg/auth-module.js